// This function allow to reference async chunks
__webpack_require__.u = function(chunkId) {
	// return url for filenames not based on template
	if (chunkId === 91) return "static/chunks/91-2af118b9692c4cbf.js";
	// return url for filenames based on template
	return "static/chunks/" + chunkId + "." + {"126":"2df06baca81be719","161":"b0ab8614cba1590e","258":"d58c14a4a9f1c1bf","263":"b413d26cc870541d","296":"56f4567ee30b18db","479":"d575705b1b3b3f56","688":"ad6f4283d5add1c5","768":"eb8f122041494fe6","949":"233e1ba092f1b6e3"}[chunkId] + ".js";
};